export default __webpack_public_path__ + "static/media/kw.7f56ef56.svg";